import 'expo-dev-client';
import './styles/globalScrollbar';
import { StatusBar } from 'expo-status-bar';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import useCachedResources from './hooks/useCachedResources';
import useColorScheme from './hooks/useColorScheme';
import Navigation from './navigation';

import Toast, { ToastProvider } from 'react-native-toast-notifications'
import BrandToast from './components/BrandToast'


//  react-query
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './utils/queryClient'


// Configuración twrnc
import tw from "./styles/tailwind";
import { useDeviceContext } from 'twrnc'

import Constants from 'expo-constants'



//-------------------------Configuración redux-------------------------------------------//
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import configureStore from "./store/configureStore";

const { store, persistor } = configureStore();
//--------------------------------------------------------------------------------------//



//-------------------------Configuración de API-------------------------------------------//
import api from "./utils/api";
import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import useCheckAppUpdate from './hooks/useCheckAppUpdate';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import * as Sentry from '@sentry/react-native';

Sentry.init({
  dsn: 'https://dc0346a36f7615661e72603d15ce1731@o4511653133680640.ingest.us.sentry.io/4511653138923520',

  // Adds more context data to events (IP address, cookies, user, etc.)
  // For more information, visit: https://docs.sentry.io/platforms/react-native/data-management/data-collected/
  sendDefaultPii: true,

  // Enable Logs
  enableLogs: true,

  // Configure Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  integrations: [Sentry.mobileReplayIntegration()],

  // uncomment the line below to enable Spotlight (https://spotlightjs.com)
  // spotlight: __DEV__,
});

// api.defaults.baseURL = process.env.API_URL // Para usar con dot-env (no instalado por default)
api.defaults.baseURL = Constants.expoConfig?.extra?.API_URL;



// Para inyectar el token en las peticiones
api.interceptors.request.use(config => {
  const { auth } = store.getState()

  config.headers.Accept =  'application/json';

  if (auth.isLogged) {
    config.headers.Authorization = `Bearer ${auth.token}`
  }

  console.log(`[API] ${config.method} - ${config.url}`);
  

  return config;
}, error => {
  return Promise.reject(error);
});


// Response interceptor
api.interceptors.response.use(response => {
  // Cualquier http 2xx
  return response;
}, function (error) {
  // TODO
  // error.response.status === 401
  return Promise.reject(error);
})
//--------------------------------------------------------------------------------------//



export default Sentry.wrap(function App() {
  const isLoadingComplete = useCachedResources();
  const colorScheme = useColorScheme();

  useDeviceContext(tw);
  
  useCheckAppUpdate()


  if (!isLoadingComplete) {
    return null;
  } else {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <ToastProvider
              offsetTop={80}
              renderToast={(toast) => <BrandToast message={toast.message} type={toast.type} />}
            >

              {/*
                El GestureHandlerRootView es para este fix del gorhom bottomsheet
                https://github.com/gorhom/react-native-bottom-sheet/issues/1373#issuecomment-1550661599 
              */}
              <GestureHandlerRootView style={{flex: 1}}>
                <BottomSheetModalProvider>

                <SafeAreaProvider>
                  <Navigation colorScheme={colorScheme} />
                  <StatusBar />
                </SafeAreaProvider>

                </BottomSheetModalProvider>
              </GestureHandlerRootView>
            </ToastProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    );
  }
});
